import { create } from "zustand";

export const useMagnifierStore = create((set, get) => ({
  // ── Magnifier State ──
  isEnabled: false,
  mode: "cursor", // "cursor" | "manual" | "auto" | "selection" | "draw" | "ai"
  size: 200, // 50 to 500
  scale: 2.0, // 1.2 to 10.0
  shape: "circle", // "circle" | "rectangle"
  borderColor: "#22c55e", // Green matching the app accent
  borderWidth: 3,
  opacity: 0.9,
  duration: 300, // animation transition in ms
  frozen: false,
  halo: true,
  backgroundBlur: true,
  position: { x: 0, y: 0 },
  zoomTarget: null, // { x, y, w, h } for word/command/selection zooms
  zoomProgress: 0, // 0 to 1 for animations

  // ── Actions ──
  toggleEnabled: () => set((state) => ({ isEnabled: !state.isEnabled })),
  setEnabled: (isEnabled) => set({ isEnabled }),
  setMode: (mode) => set({ mode }),
  updateSettings: (settings) => set((state) => ({ ...state, ...settings })),
  setPosition: (position) => set((state) => {
    if (state.frozen) return {};
    return { position };
  }),
  setZoomTarget: (zoomTarget) => set({ zoomTarget }),
  setZoomProgress: (zoomProgress) => set({ zoomProgress }),
  setFrozen: (frozen) => set({ frozen }),
}));
